


































































  import { Vue, Prop, Component, Watch } from 'vue-property-decorator';
  import { InputValidation } from '../../../helpers/inputValidation';
  import { Environment } from '../../../helpers/Environment';
  import { CanvasBannerPlaceholder, ICanvasBannerPlaceholder, Format, CanvasBannerPlaceholderFormat } from '@models';
  import { PropType } from 'vue';
import { clone } from 'lodash';


  @Component
  export default class CanvasBannerPlaceholderEditor extends Vue {
    name = 'canvas-banner-placeholder-editor';
    inputValidation = InputValidation;
    environment: Environment = new Environment();

    @Prop({
      type: Array as PropType<ICanvasBannerPlaceholder[]>,
      default: () => []
    })
    values: ICanvasBannerPlaceholder[];

    foundPlaceholders: string[] = [];
    placeholders: Array<ICanvasBannerPlaceholder> = new Array<ICanvasBannerPlaceholder>();

    @Prop(String) sourcetext: string;
    @Prop({ type: String, default: "" }) formatversionid: string;
    @Prop({ type: Boolean, default: true }) showhint: boolean;

    @Watch("placeholders", { deep: true })
    updateValue() {
      this.$emit('input', this.placeholders);
    }

    @Watch("sourcetext")
    findPlaceholders() {
      if (this.sourcetext) {
        const regexp = /\[\[(\w+)\]\]/g;
        const result = this.sourcetext.match(regexp);
        this.foundPlaceholders = result ? Array.from(result) : [];
      }
    }

    addPlaceholderShorthand(ev: Event, placeholderTag: string) {
      if (placeholderTag) {
        var placeholder = new CanvasBannerPlaceholder();
        placeholder.tag = placeholderTag
        this.addPlaceholder(ev, placeholder);
      }
    }

    async addPlaceholder(ev: Event, placeholder: ICanvasBannerPlaceholder = null) {
      if (!placeholder) {
        placeholder = new CanvasBannerPlaceholder();
      }

      this.placeholders = [...this.placeholders, placeholder];
    }

    removePlaceholder(placeholder: ICanvasBannerPlaceholder) {
      this.placeholders = this.placeholders.filter(x => x.tag !== placeholder.tag);
    }

    chosenFormatList(placeholderTag: any) {
      var formats = [];
      if (this.placeholders.find(x => x.tag === placeholderTag)) {
        var canvasBannerPlaceholderFormats = this.placeholders.find(x => x.tag === placeholderTag).canvasBannerPlaceholderFormats;
        if (canvasBannerPlaceholderFormats) {
          canvasBannerPlaceholderFormats.forEach(canvasBannerPlaceholderFormat => {
            formats.push(canvasBannerPlaceholderFormat.format);
          });

          return formats;
        }
      }

      return undefined;
    }

    bannerSelected(formats: Array<Format>, placeholderTag: any) {
      if (this.placeholders.find(x => x.tag === placeholderTag)) {
        this.placeholders.find(x => x.tag === placeholderTag).canvasBannerPlaceholderFormats = [];
        var canvasBannerPlaceholderFormats = [];
        formats.forEach(format => {
          let phf = new CanvasBannerPlaceholderFormat();
          phf.format = format;
          canvasBannerPlaceholderFormats.push(phf);
        });

        this.placeholders.find(x => x.tag === placeholderTag).canvasBannerPlaceholderFormats = canvasBannerPlaceholderFormats;
        // We do this to ensure the watcher us notified about the changes since VUE is not good at handling arrays inside arrays.
        this.placeholders = clone(this.placeholders);
      }
    }

    async created() {
      this.placeholders = this.values;
      this.findPlaceholders();
    }
  }
